import configureStore from 'store/configureStore'

const { store, history } = configureStore()

export default store
export { history }
